import React from "react";

const Loader = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
      width={width}
      height={height}
      style={{
        shapeRendering: "auto",
        display: "block",
      }}
    >
      <defs>
        <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style={{ stopColor: "#228BE6" }} />
          <stop offset="100%" style={{ stopColor: "#B3DFFA" }} />{" "}
        </linearGradient>
      </defs>
      <g>
        <circle
          cx="50"
          cy="50"
          fill="none"
          stroke="url(#gradient)"
          strokeWidth="10"
          strokeLinecap="round"
          r="42"
          strokeDasharray="197.92033717615698 67.97344572538566"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            repeatCount="indefinite"
            dur="1.408450704225352s"
            values="0 50 50;360 50 50"
            keyTimes="0;1"
          />
        </circle>
        <g />
      </g>
    </svg>
  );
};

export default Loader;
